@for(years of viewGroupedData; let index = $index; track years.year) {
<div class="se-timeline-outer-container"
     [ngClass]="{'last-item-container': index === viewGroupedData.length - 1}"
     [style.width.px]="sectionSize">
    <div class="timeline-line-container">
        <div class="timeline-years">{{years.year}}</div>
        <div class="timeline-line" [ngClass]="{'odd-color': 0 === index % 2, 'last-item': index === viewGroupedData.length - 1, 'is-single-year' : viewGroupedData.length === 1}">
            <mat-divider></mat-divider>
        </div>
    </div>
    <div class="se-timeline-inner-container" [ngClass]="{'is-single-year' : viewGroupedData.length === 1}">
        @for(month of years.months; track month.visits; let monthIndex = $index) {
        <div class="timeline-months" [ngClass]="{'hide': month.hide}" [style.width.px]="month.availableSpace">
            @if(viewGroupedData.length === 1) {
            <span class="month-separator"></span>
            }
            @if(!month.grouped) {
            <div class="single-visits-container">
                @for(visit of month.visits; track visit.id; let dayIndex = $index) {
                <div class="visit-item"
                     [ngClass]="{'timeline-single-visits': singleYear, 'timeline-grouped-visits': visit.grouped}"
                     tabindex="0"
                     (click)="visit.grouped?.length <= 1 && _onItemSelection(visit)"
                     [style.left.px]="visit.position">
                    <div class="timeline-indicator"></div>

                    <!--visite singole-->
                    @if(visit.grouped?.length === 1) {
                    <img class="visit-image" [src]="_getUrl(visit.icon)" [alt]="visit.description" />
                    <div class="timeline-tooltip-custom single-tooltip" (positionChange)="_changeTooltipPosition($event)" seTimeline>
                        @for(groupedVisit of visit.grouped; let groupedIndex = $index; track groupedVisit.date) {
                        <div>
                            {{groupedVisit.date | date: 'dd/MM/yyyy'}} {{groupedVisit.description}}
                        </div>
                        }
                    </div>
                    }

                    <!--visite raggruppate nello stesso giorno-->
                    @if(visit.grouped?.length > 1) {
                    <div [matBadge]="visit.grouped?.length" matBadgeSize="small">
                        <img class="visit-image" [src]="_getUrl(visit.icon)" [alt]="'Grouped visits'" />
                    </div>

                    <div class="timeline-tooltip-custom tooltip-visit-item" (positionChange)="_changeTooltipPosition($event)" seTimeline>
                        @for(groupedVisit of visit.grouped; let groupedIndex = $index; track groupedVisit.id) {
                        <div (click)="_onSameDayItemSelection(groupedVisit)" class="single-visit-item">
                            <img class="group-visit-image" [src]="_getUrl(groupedVisit.iconName)" [alt]="groupedVisit.description" />
                            <span class="visit-description">{{groupedVisit.date | date: 'dd/MM/yyyy'}} {{groupedVisit.description}}</span>
                        </div>
                        }
                    </div>
                    }
                </div>
                }

            </div>
            }

            @else {
            <div class="timeline-grouped" tabindex="0">
                <div class="timeline-indicator"></div>
                <div [matBadge]="month.count" matBadgeSize="small">
                    <img class="visit-image" [src]="_getVisitsUrl(month.visits, month.groupedMonths, month.icon)" [alt]="'Grouped visits'" />
                </div>
                <div class="timeline-tooltip-custom tooltip-visit-item" (positionChange)="_changeTooltipPosition($event)" seTimeline>
                    @for(visit of month.visits; let visitIndex = $index; track visit.id) {
                    <div>
                        @for(sameDayVisit of visit.grouped; let sameDayIndex = $index; track sameDayVisit.id) {
                        <div (click)="_onItemSelection(sameDayVisit)" class="single-visit-item">
                            <img class="group-visit-image" [src]="_getUrl(sameDayVisit.iconName)" [alt]="sameDayVisit.description" />
                            <span class="visit-description">{{sameDayVisit.date | date: 'dd/MM/yyyy'}} {{sameDayVisit.description}}</span>
                        </div>
                        }
                    </div>
                    }
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>
}

<mat-icon [ngClass]="{'arrow-icon-full': _showUpcomingEvents}" class="arrow-icon">arrow_right</mat-icon>

@if(_showUpcomingEvents) {
<div class="visit-item">
    <mat-icon class="upcoming-events">event_upcoming</mat-icon>
    <div class="timeline-tooltip-custom tooltip-visit-item future-visits-tooltip" (positionChange)="_changeTooltipPosition($event)" seTimeline>
        @for(visit of futureVisits; track $index) {
        <div class="single-visit-item" (click)="_onItemSelection(visit)">
            <img class="group-visit-image" [src]="_getUrl(visit.iconName)" [alt]="visit.description" />
            <span class="visit-description">{{visit.date | date: 'dd/MM/yyyy'}} {{visit.description}}</span>
        </div>
        }
    </div>
</div>
}

@if(_showSpinner) {
<div class="timeline-spinner estensa-spinner"
     [ngClass]="{'timeline-spinner-no-data': !clinicalHistory.length}">
    <mat-spinner></mat-spinner>
</div>
}

